import { SCAN_ACTION_FAILURE_ACTION_NAME } from '../constants/scanActionNames.const';
import { type ScanAction, type ScanActionResult } from '../types/scanAction.type';
import { type ScanEvent } from '../types/scanEvent.type';
import { createScanActionResolutionError } from '../utils/scanActionError.util';

export const createScanActionFailureScanAction = (): ScanAction => ({
  // TODO: QPACK-463: Surface user-facing feedback for a scan that produced no action.

  execute: (
    scanEvent: ScanEvent,
    error: Error = createScanActionResolutionError(scanEvent.correlation_id),
  ): ScanActionResult => {
    // eslint-disable-next-line no-console
    console.log('Executed Action: ScanActionFailureScanAction', scanEvent, error);

    return { error, success: false };
  },

  matches: () => true,

  name: SCAN_ACTION_FAILURE_ACTION_NAME,
});
